import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>
                    Spijsvertering systeem: wat gebeurd er met een hap eten?
                </title>
                <link rel="canonical" href={route("blogs.twentieth")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Ons darmkanaal regelt onze ‘binnenwereld’. De perfect uitgevoerde werkzaamheden starten bij de mond, het portaal naar de wereld van onze darmen. Ons darmkanaal is daarom een onderschatte factor als het gaat om een snelle transformatie. In deze nieuwe blog van WE ARE – personal training Uden en Schijndel duiken we dieper in op ons spijsvertering systeem!"
                />
                <meta
                    property="og:description"
                    content="Ons darmkanaal regelt onze ‘binnenwereld’. De perfect uitgevoerde werkzaamheden starten bij de mond, het portaal naar de wereld van onze darmen. Ons darmkanaal is daarom een onderschatte factor als het gaat om een snelle transformatie. In deze nieuwe blog van WE ARE – personal training Uden en Schijndel duiken we dieper in op ons spijsvertering systeem!"
                />
                <meta property="og:url" content={route("blogs.twentieth")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Spijsvertering systeem: wat gebeurd er met een hap eten? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/spijsvertering-systeem.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/spijsvertering-systeem.webp"
                                    type="image/webp"
                                    alt="Spijsvertering systeem"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/spijsvertering-systeem.jpg"
                                    type="image/jpeg"
                                    alt="Spijsvertering systeem"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/spijsvertering-systeem.jpg"
                                    alt="Spijsvertering systeem"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Spijsvertering systeem: wat gebeurd er met een hap eten?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Ons darmkanaal regelt onze ‘binnenwereld’. De perfect
                        uitgevoerde werkzaamheden starten bij de mond, het
                        portaal naar de wereld van onze darmen. Ons darmkanaal
                        is daarom een onderschatte factor als het gaat om een
                        snelle transformatie. In deze nieuwe blog van WE ARE –
                        personal training Uden en Schijndel duiken we dieper in
                        op ons spijsvertering systeem!{" "}
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        De start van het darmkanaal
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        De ingang van onze spijsvertering heeft veel te bieden,
                        wist je dat? De start van onze spijsvertering start
                        namelijk in onze mond, een gebied vol superlatieven.
                        Deze ingang heeft een aantal geheimpjes!
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Ten eerste zijn het onze vier speeksel puntjes. Deze
                        puntjes kan je voelen met je tong. Als je goed voelt,
                        voel je een kleine verhoging in je wang tegenover de
                        bovenste rij tanden. Hier zitten er twee verstopt die
                        jij al je hele leven meedraagt zonder dat je het wist.
                        De overige twee zitten onder onze tong.
                    </p>
                    <img
                        className="w-auto h-46 object-cover my-4 mr-2 inline"
                        src="/assets/blog/speekselklieren.jpeg"
                        alt="Speekselklieren"
                    />
                    <img
                        className="w-auto h-46 object-cover my-4 ml-2 inline"
                        src="/assets/blog/speekselklieren-wang.jpeg"
                        alt="Speekselklieren wang"
                    />
                    <p className="mt-4 text-gray-100 break-words">
                        Uit deze speeksel puntjes komt speeksel maar tussen deze
                        puntjes zit een groot verschil! De speeksel puntjes in
                        de wang produceren alleen speeksel als hier aanleiding
                        voor is, denk bijvoorbeeld aan het moment wanneer er
                        eten in onze mond komt. De speeksel puntjes onder onze
                        tang produceren continu speeksel. Jouw hoofd
                        speekselklier produceert wel tot 1 liter speeksel per
                        dag! Deze aanmaakt wordt ’s nachts geremd. Stel je voor
                        iemand die op zijn kussen sabbelt en 1 liter speeksel
                        produceert..
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Speeksel is eigenlijk niets anders dan gefilterd bloed.
                        Het bloed wordt namelijk gefilterd in de
                        speekselklieren. De rode bloedcellen worden hier een
                        halt toegeroepen omdat we deze niet nodig hebben in onze
                        mond maar in onze aderen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Wist je dat onze speeksel een geheim heeft om ervoor te
                        zorgen dat we altijd kunnen eten zonder pijn wanneer we
                        toch kleine wondjes in de mond hebben? Speeksel bevat
                        namelijk de stof opiorfine! Deze natuurlijke pijnstiller
                        is sterker dan morfine. Wat voelt je als je een keer
                        slikt wanneer je keelpijn hebt? Precies, een soort
                        verlichtend gevoel! Opiorfine!
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Naast opiorfine bevat ons speeksel ook mucrine. Deze
                        stof beschermt onze mond tegen teveel foute bacteriën.
                        Je moet het zien als dat er een spinnenweb aan mucrine
                        in je mond wordt gemaakt zoals spinnen doen en eenmaal
                        gevangen in dit web worden deze foute bacteriën gedood
                        voordat ze ons kunnen aanvallen. Zowel opiorfine als
                        mucrine zijn goed in balans anders zouden we een
                        overdreven ontsmetten mond krijgen die volledig verdoofd
                        is!
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Het tweede grote geheim zit hem in gedeeltes die we
                        eigenlijk niet kunnen zien. Het gaat namelijk om je tong
                        wortel! Je kunt deze wel voelen als je helemaal
                        achteraan je tong kunt komen met je vinger zonder over
                        te moeten geven! Je voelt hier wat ‘bobbeltjes’. Deze
                        bobbeltjes testen alles wat er naar binnen gaat; eten,
                        drinken maar ook lucht. Zij vallen de gevaarlijke
                        stofjes aan die bijvoorbeeld keelpijn veroorzaken. Deze
                        ‘bobbeltjes’ is een nieuwsgierige hotspot van ons
                        lymfeweefsel. Het doel is simpel: het aftasten van alles
                        wat onbekend is en dit aanvallen met immuuncellen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        De sterkste spier van ons lichaam; de kaak, bevindt zich
                        ook in onze mond. Samen met de tong verricht hij
                        superieur werk. Met onze kaken kunnen we per kies een
                        druk uitoefenen van wel tachtig kilo (!!) zodat ons
                        voedsel goed wordt vermalen. Onze tong dient als coach.
                        Wanneer er voedsel niet goed tussen de kiezen komt
                        stuurt de tong het voedsel de juiste weg. Is het voedsel
                        goed genoeg gemalen pakt de tong ongeveer 20 milliliter
                        voedsel en stuur hem richting slokdarm.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        De samenstelling van onze darmen
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Vanaf onze mond komen we in onze slokdarm terecht en
                        vervolgens in onze maag. De rechterkant van onze maag is
                        korter dan de linker. We vervolgen onze weg met een
                        zeven meter lange dunne darm die tot slot overgaat in
                        onze dikke darm. Hieraan hangt dan weer een nutteloze
                        blinde darm. Weinig tot geen charme dus vanuit onze
                        darmen maar vergeet niet dat deze wereld complex en
                        wonderbaarlijk is!
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl">
                        1. De slokdarm
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Na onze mond komen we als eerst in onze slokdarm
                        terecht. De slokdarm is ongeveer 30 cm lang en 2 cm
                        breed en het duurt ongeveer vijf tot zes seconden voor
                        een hap voedsel om deze 30 cm af te leggen. Als de hap
                        eraan komt beweegt de slokdarm als een soort wave in een
                        stadion. De slokdarm plugged in in de rechterkant van
                        onze maag in. De slokdarm ziet er in eerste instantie
                        gekker uit dan hij is. In de slokdarmwand zitten
                        allemaal kleine spieren die onze voedsel transporteren
                        van mond naar maag. Wanneer we deze spieren zouden
                        uitrekken zouden ze eruit zien als een telefoondraad.
                        Het stukje voedsel wordt stukje voor stukje naar beneden
                        geduwd. Dit noemen we peristaltische bewegingen.
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl">
                        2. De maag
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Via de slokdarm komen we in de maag terecht. De maag zit
                        vaak niet op de plek waar de meeste mensen denken. De
                        plek: vlak onder de linkertepel en eindigt onder het
                        rechter ribboog. De ene kant van de maag is veel langer
                        dan de andere kant. Er zitten tevens grote vouwen in de
                        maag; de Quasimodo van de spijsvertering. Maar de maag
                        is super slim en doordat hij deze vorm aanneemt kan hij
                        twee dingen onderscheiden. Vloeistof en vast voedsel.
                        Vloeistoffen kunnen direct via de rechterkant door
                        richting de dunne darm terwijl vast voedsel wordt
                        tegengehouden en via de linkerkant eerst in de kneed
                        molen terecht komt. Naast dat de maag niet op de plek
                        zit waar de meeste mensen denken is hij ook veel
                        beweeglijker. Zolang er eten in de maag terecht komt kan
                        hij steeds verder uitrekken, plaats voor iedereen!
                        Emoties zoals stress kunnen dit proces verstoren en
                        vandaar dat sommige mensen ‘geen hap door hun keel’
                        krijgen wanneer ze veel stress ervaren. Wanneer de hap
                        eten in de maag is versnelt de maag zijn beweging en
                        gooit het eten tegen de maagwand aan die vervolg weer
                        terug glijdt: retropulsie. Als dit gebeurd zetten ook de
                        darmen hun wanden ook in werking waardoor er plaats
                        gemaakt wordt voor nieuwe deelnemers, gevolg: een
                        toiletbezoek!
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl">
                        3. De dunne darm
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Na onze maag komt een drie tot zes meter lange dunne
                        darm. Hier begint de spijsvertering reis pas echt.
                        Happen eten verdwenen hier helemaal in de wand van onze
                        darmen zoals de kinderen in de kledingkast bij de film
                        Narnia. Van de binnenkant is deze darm glanzend, nat,
                        roze en een beetje zacht. Verbazingwekkend schoon!
                        Wanneer we het bekijken op minuscuul niveau zien we
                        miljoenen vlokjes. Op deze vlokjes zitten wéér vlokjes,
                        vlokjes op vlokjes dus! De belangrijkste fase van de
                        spijsvertering vindt plaats in deze darm. Het voedsel
                        wordt door middel van schaartjes (lees: enzymen) geknipt
                        tot het voedsel net zo klein is als onze lichaamscellen.
                        Op elk vlokje van de dunne darm zit dan weer een
                        bloedvaatje, dat wordt gevoed door de deze moleculen
                        (verteerd voedsel). Alle vaten van de dunne darm komen
                        bij elkaar en stromen richting onze lever.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Op naar de dikke darm of toch niet? Onze dunne darm
                        houdt van een schone werkplek. Een uur nadat de dunne
                        darm iets heeft verteerd begint hij zichzelf schoon te
                        maken (= migrerend motorisch complex). Je hoort dit wel
                        eens: het knorren van je maag (maar dat zijn je
                        darmen!).
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl">
                        4. De dikke darm
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Via het uiteinde van de dunne darm en de klep van Bauhin
                        volgt de dikke darm. De dikke darm ligt als een
                        schilderijlijstje om de dunne darm heen. De dikke darm
                        neemt de tijd voor alles wat na het voorgaande proces is
                        overgebleven en verteert dat helemaal. Hij wordt zo drie
                        tot vier keer per dag actief om het overgebleven deel
                        naar voren te duwen tot aan de uitgang bereikt is.
                        Restanten van eten worden ongeveer zestien uur lang nog
                        een keer bewerkt in de dikke darm. Belangrijke stoffen
                        zoals calcium kunnen hier pas echt worden opgenomen. In
                        de laatste meter dikke darm wordt ook het water,- en
                        zouthuishouding geregeld. Ook in de dikke darm stuurt
                        via bloedvaatjes zijn stoffen richting de lever.
                        Gemiddeld duurt deze hele reis van hap tot poepen
                        gemiddeld één dag. Dit scheelt per persoon afhankelijk
                        van de gezondheid van je darmen.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
